import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Button, Grid } from '@mui/material';
import { FiltersButtons, FiltersLayout, SearchField } from '../../../components';
import { ManagePartsFiltersDropdown } from './manage-parts-filters-dropdown';
import { Search } from '@mui/icons-material';

interface IManagePartsFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setPage: (val: number) => void;
  setHasAppliedFilters: (val: boolean) => void;
  hasAppliedFilters?: boolean;
  searchValue: string;
  setSearchValue: (val: any) => void;
  handleSearch: (val?: string) => void;
  setSelectedPartClassIdFilter: React.Dispatch<React.SetStateAction<string | null>>;
}

export const ManagePartsFilters: FC<IManagePartsFilters> = ({
  hasAppliedFilters,
  setHasAppliedFilters,
  isLoading,
  applyFilters,
  setPage,
  searchValue,
  setSearchValue,
  handleSearch,
  setSelectedPartClassIdFilter
}) => {
  const classes = useStyles();

  const handleReset = () => {
    setHasAppliedFilters(false);
    setSelectedPartClassIdFilter?.(null);
    setSearchValue?.('');
    applyFilters(true);
    setPage(0);
  };
  return (
    <FiltersLayout>
      <Grid item xs={12} md={6} className={classes.searchWrapper}>
        <SearchField
          isDisabled={isLoading}
          handleSearch={(val: string) => {
            handleSearch(val);
            setHasAppliedFilters(true);
            applyFilters();
          }}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
        <div className={classes.searchButtonWrapper}>
          <Button
            variant="contained"
            color="secondary"
            disabled={isLoading}
            startIcon={<Search />}
            className={classes.searchButton}
            onClick={() => {
              setHasAppliedFilters(true);
              applyFilters();
            }}
          >
            Search
          </Button>
        </div>
      </Grid>
      <Box width="100%" />
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <ManagePartsFiltersDropdown
            partClassId={null}
            depth={0}
            setSelectedPartClassIdFilter={setSelectedPartClassIdFilter}
            hasAppliedFilters={hasAppliedFilters}
          />
        </Grid>
      </Grid>
      <Box width="100%" />
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            handleReset();
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  },
  searchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      width: 'auto'
    }
  },
  searchButtonWrapper: {
    flex: 1,
    margin: `1rem 0`,
    [theme.breakpoints.up('sm')]: {
      margin: 0
    }
  },
  searchButton: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: '8rem',
      width: 'auto'
    },
    height: 40
  }
}));
